<template>
  <div class="flex flex-col flex-grow h-full">
    <navbar-component></navbar-component>
    <div class="relative flex flex-col items-center flex-grow w-full overflow-x-hidden overflow-y-scroll">
      <slot />
    <footer-component class="w-full mt-10"></footer-component>
    </div>
  </div>
</template>

<script>
import NavbarComponent from './Navbar.vue';
import FooterComponent from './Footer.vue';

export default {
  name: 'ViewWrapper',
  data() {
    return {
      items: [],
      search: '',
    };
  },
  components: {
    NavbarComponent,
    FooterComponent,
  },
};
</script>
